module.exports = "/assets/data/47c38826ec6865a6e0b99d9bc093d766-SK17.data.json";